import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';

import IncmsService from 'services/IncmsService'
import ChannelCaseService from 'services/ChannelCaseService'
import { Checkbox, FormGroup, Select, Textarea } from 'components/FormElements/';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required } from 'constants/InputErrors';

class AddContactModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      types: [],
      reasons: [],
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( !this.props.open && nextProps.open ) {
      this.getData()
    }
  }

  getData() {
    this.props.toggleLoading( true );

    IncmsService.getCaseTypes().then( ( response ) => {
      this.props.toggleLoading( false );

      if ( response.data ) {
        this.setState( { types: response.data } );
      }
    } );
  }

  getReasons( type ) {
    if ( !type ) return this.setState( { reasons: [] } );

    this.props.toggleLoading( true );

    IncmsService.getCaseReasons( type ).then( ( response ) => {
      this.props.toggleLoading( false );

      if ( response.data ) {
        this.setState( { reasons: response.data } );
      }
    } );
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'contact';
    data.account = this.props.activeAccount.id;
    ChannelCaseService.saveCase( data ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) return toggleAlertError( response.errors );

      onReloadData();
      onClose()
    } )
  }

  render() {
    const { onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addContact"/></h5>

        <Form onSubmit={this.submitForm}
              validate={( values ) => {
                return {
                  contactType: required( values.contactType ),
                  contactReason: required( values.contactReason ),
                  registerComment: required( values.registerComment )
                }
              }}
        >
          {( { getValue, setValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="type"/></label>
                  <Select field="contactType" className="form-control" placeholder=""
                          valueKey="codeType" labelKey="descriptionType"
                          options={this.state.types}
                          onChange={( value ) => {
                            setValue( 'contactReason', null );
                            this.getReasons( value )
                          }}
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="reason"/></label>
                  <Select field="contactReason" className="form-control" placeholder=""
                          valueKey="codeReason" labelKey="descriptionReason"
                          options={this.state.reasons}/>
                </FormGroup>
              </div>

              <FormGroup>
                <label><Translate id="comment"/></label>
                <Textarea field="registerComment" className="form-control" rows={5}/>
              </FormGroup>

              <FormGroup>
                <Checkbox field="contactEmergency" label={<Translate id="emergency"/>}
                          labelStyle={{ width: 'auto' }}/>
              </FormGroup>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( AddContactModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddContactModal/index.js